__turbopack_context__.v({
  "button": "ui-module__NWB9nG__button",
  "click": "ui-module__NWB9nG__click",
  "cursor": "ui-module__NWB9nG__cursor",
  "cursorBody": "ui-module__NWB9nG__cursorBody",
  "cursorDown": "ui-module__NWB9nG__cursorDown",
  "dots": "ui-module__NWB9nG__dots",
  "draw": "ui-module__NWB9nG__draw",
  "lifted": "ui-module__NWB9nG__lifted",
  "loop": "ui-module__NWB9nG__loop",
  "outline": "ui-module__NWB9nG__outline",
  "packet": "ui-module__NWB9nG__packet",
  "panel": "ui-module__NWB9nG__panel",
  "ping": "ui-module__NWB9nG__ping",
  "pop": "ui-module__NWB9nG__pop",
  "pressed": "ui-module__NWB9nG__pressed",
  "primary": "ui-module__NWB9nG__primary",
  "shimmer": "ui-module__NWB9nG__shimmer",
  "spin": "ui-module__NWB9nG__spin",
  "travel": "ui-module__NWB9nG__travel",
  "travel-loop": "ui-module__NWB9nG__travel-loop",
  "ui": "ui-module__NWB9nG__ui",
});
